export default __webpack_public_path__ + "static/media/avatar_cow8.68d7bcdd.mp3";